import React from 'react';

export const deliveryLabel = method =>
	method === 'discord_dm' ? 'Discord DM' : 'Discord channel mention';

export default function DeliveryMethods({
	method,
	dmAvailable,
	disabled,
	onChange
}) {
	return (
		<fieldset
			className="settings-section delivery-methods"
			disabled={disabled}
		>
			<legend>Delivery method</legend>
			{[
				[
					'channel_mention',
					'Discord channel mention',
					'Tag me on matching deals in the channel feed.'
				],
				[
					'discord_dm',
					'Discord DM',
					'Send me a private alert with a link to the listing.'
				]
			].map(([value, label, description]) => (
				<label className="setting-checkbox" key={value}>
					<input
						type="radio"
						name="notification-method"
						value={value}
						checked={method === value}
						disabled={value === 'discord_dm' && !dmAvailable}
						onChange={() => onChange(value)}
					/>
					<span>
						<strong>{label}</strong>
						<small>{description}</small>
					</span>
				</label>
			))}
			<p className="field-help">
				Applies to all your watches. Deals will still appear in the
				channel feed.
			</p>
			<p className="field-help">
				{dmAvailable
					? 'To receive DMs, allow direct messages from members of the TCGDrop Discord server.'
					: 'Discord DMs are temporarily unavailable. Channel mentions are still available.'}
			</p>
			<div className="upcoming-method">
				<span>Browser push</span>
				<small>Coming soon</small>
			</div>
		</fieldset>
	);
}
